import React from "react";
import { Table, TableHeader, TableColumn, TableBody, TableRow, TableCell } from "@nextui-org/react";

import "./Leaderboard.css";

function Leaderboard(props) {
  const displayNum = 3;
  let empty = { firstName: "" };
  empty[props.displayField] = "";
  let data = Array(displayNum).fill(empty);
  if (props.data.length > 0) {
    data = props.data.sort((a, b) => b[props.displayField] - a[props.displayField]);
  }

  const showMedal = (rank) => {
    switch(rank) {
      case 1:
        return '🥇';
      case 2:
        return '🥈';
      case 3:
        return '🥉';
      default:
        return '🥇';
    }
  }

  return (
    <Table aria-label="Example static collection table">
      <TableHeader>
        <TableColumn className="text-base font-semibold">Rank</TableColumn>
        <TableColumn className="text-base font-semibold">Name</TableColumn>
        <TableColumn className="text-base font-semibold">Points</TableColumn>
      </TableHeader>
      <TableBody>
        {data.slice(0, displayNum).map((row, index) => (
          <TableRow key={index + 1} className="h-[56px]">
            <TableCell className="text-base font-bold">{showMedal(index + 1)}</TableCell>
            <TableCell className="text-base">{row.displayName}</TableCell>
            <TableCell className="text-base">{row[props.displayField]}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

// const styles =
// {
//     headText :
//     {
//         // fontSize: "1.0vw",
//         // fontWeight: 'bold'
//     },
//     bodyText :
//     {
//         // fontSize: "1.0vw",
//     }
// }

export default Leaderboard;
